import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Band, PullQuote } from './Band';
import { comparisonRows } from '../../data/site';
export function Positioning() {
  return <Band id="product" eyebrow="Assessment, not surveillance" title="Detection watches candidates. Lentic measures judgement." description="Detectors break on every model release, and they punish people for using the tools their job requires. The failure mode is a false accusation you then have to defend, against a candidate who did nothing wrong." aside={<PullQuote data-id="element-316" data-mp="351243t5kxfjd">
          We don't detect AI use. We assume it, supply it, and measure what the
          candidate does with what it gives them.
        </PullQuote>} data-id="element-315" data-mp="2mastpvzn2hgl">
      {/* Mobile: stacked comparison cards */}
      <ul className="grid gap-3 md:hidden" data-id="element-317" data-mp="3e2i5jbef27bg">
        {comparisonRows.map(row => <li key={row.axis} className="rounded-2xl border border-mist bg-white/70 p-5" data-id="element-318" data-mp="3j0a6sw0yb5sb">
            <p className="font-mono text-xs uppercase tracking-[0.12em] text-teal" data-id="element-319" data-mp="2lj4wql4p2zdp">
              {row.axis}
            </p>
            <div className="mt-4 space-y-4" data-id="element-320" data-mp="2hf6va3rwdchh">
              <div className="flex items-start gap-2.5" data-id="element-321" data-mp="2cgvjhni1krwm">
                <XIcon className="mt-1 h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-322" data-mp="2cjhqnm10t5eb" />
                <div data-id="element-323" data-mp="27jvgxmkei7a9">
                  <p className="font-mono text-[11px] uppercase tracking-[0.1em] text-muted" data-id="element-324" data-mp="27kn90neshmvs">
                    AI detection
                  </p>
                  <p className="mt-1 text-[15px] leading-snug text-muted" data-id="element-325" data-mp="3080yk0g5rg5v">
                    {row.detection}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2.5 border-t border-mist pt-4" data-id="element-326" data-mp="2qhg0qf8b6fo0">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-327" data-mp="3nwk6gevapqxf" />
                <div data-id="element-328" data-mp="3nydhs7guszbr">
                  <p className="font-mono text-[11px] uppercase tracking-[0.1em] text-teal" data-id="element-329" data-mp="3j63qoo405t7w">
                    Lentic
                  </p>
                  <p className="mt-1 text-[15px] font-medium leading-snug text-ink" data-id="element-330" data-mp="1h8tnioeszxpm">
                    {row.lentic}
                  </p>
                </div>
              </div>
            </div>
          </li>)}
      </ul>

      {/* Tablet and up: full table */}
      <div className="hidden overflow-hidden rounded-2xl border border-mist bg-white/70 md:block" data-id="element-331" data-mp="1cgs149nx8qlv">
        <table className="w-full border-collapse text-left" data-id="element-332" data-mp="xk1aaosbcn7v">
          <caption className="sr-only" data-id="element-333" data-mp="xmnfwivn8sng">AI detection compared with Lentic</caption>
          <thead data-id="element-334" data-mp="12haxdxs8cmsj">
            <tr className="border-b border-mist bg-bone/60" data-id="element-335" data-mp="ojmdot9wflp2">
              <th scope="col" className="w-1/5 px-6 py-5" data-id="element-336" data-mp="ol79snbv3cp1">
                <span className="sr-only" data-id="element-337" data-mp="ti7f2w0w0bf3">Dimension</span>
              </th>
              <th scope="col" className="px-6 py-5" data-id="element-338" data-mp="2ixnmo6z5xp2v">
                <span className="flex items-center gap-2 font-display text-lg font-medium text-muted" data-id="element-339" data-mp="2iyynbxxbagpr">
                  <XIcon className="h-4 w-4 text-clay" aria-hidden="true" data-id="element-340" data-mp="2nw8cdcgsgqd2" />
                  AI detection
                </span>
              </th>
              <th scope="col" className="px-6 py-5" data-id="element-341" data-mp="2t1u9t507qkxa">
                <span className="flex items-center gap-2 font-display text-lg font-medium text-ink" data-id="element-342" data-mp="2t35ed71hfwpg">
                  <CheckIcon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-343" data-mp="36ujzpkiv49zo" />
                  Lentic
                </span>
              </th>
            </tr>
          </thead>
          <tbody data-id="element-344" data-mp="3gq3ntkr6q4dv">
            {comparisonRows.map(row => <tr key={row.axis} className="border-b border-mist/70 last:border-0" data-id="element-345" data-mp="3bsbz0zlu6ydw">
                <th scope="row" className="px-6 py-5 align-top font-mono text-xs uppercase tracking-[0.12em] text-teal" data-id="element-346" data-mp="3bug4hlzdw5ga">
                  {row.axis}
                </th>
                <td className="px-6 py-5 align-top text-base leading-snug text-muted" data-id="element-347" data-mp="1vdag8xzqhhyd">
                  {row.detection}
                </td>
                <td className="px-6 py-5 align-top text-base font-medium leading-snug text-ink" data-id="element-348" data-mp="1rdt9804nscr3">
                  {row.lentic}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Band>;
}